<template>
  <div
    v-if="user"
    class="white_box table_component type_1 template_block report_page"
  >
    <div class="flex items-center mb_8 table_head">
      <h3 class="heading_h4 font_bold mr_auto">
        {{ tableTitle }}
      </h3>
      <div
        v-if="selected.length === 0 || (!canEditReports && !canEditTemplates)"
        class="head_settings"
      >
        <div class="flex items-center wrap">
          <custom-search @search="value => {(value) ? searchTemplates(value) : fetchTemplates()}" />
        </div>
      </div>

      <div
        v-else
        class="items_btns"
      >
        <div class="flex items-center">
          <a
            v-if="selected.length === 1 && canEditReports"
            class="btn btn_md secondary_btn"
            href="javascript:;"
            @click="createFrom(selected[0], 'report')"
          >
            <i class="icon create_new_icon" />
            <span class="p_small font_bold">Use to Create Report</span>
          </a>
          <a
            v-if="selected.length === 1 && canEditTemplates"
            class="btn btn_md secondary_btn"
            href="javascript:;"
            @click="createFrom(selected[0], 'template')"
          >
            <i class="icon create_new_icon" />
            <span class="p_small font_bold">Use to Create Template</span>
          </a>
          <a
            v-if="canEditTemplates"
            class="btn btn_md primary_btn delete_btn mb-0"
            data-type="templates"
            href="javascript:;"
            @click="deleteSelected()"
          >
            <svg
              fill="none"
              height="15"
              viewBox="0 0 14 15"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.8125 3.5625L2.1875 3.56251"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M5.6875 6.1875V9.6875"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M8.3125 6.1875V9.6875"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M10.9375 3.5625V11.875C10.9375 11.991 10.8914 12.1023 10.8094 12.1844C10.7273 12.2664 10.616 12.3125 10.5 12.3125H3.5C3.38397 12.3125 3.27269 12.2664 3.19064 12.1844C3.10859 12.1023 3.0625 11.991 3.0625 11.875V3.5625"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                d="M9.1875 3.5625V2.6875C9.1875 2.45544 9.09531 2.23288 8.93122 2.06878C8.76712 1.90469 8.54456 1.8125 8.3125 1.8125H5.6875C5.45544 1.8125 5.23288 1.90469 5.06878 2.06878C4.90469 2.23288 4.8125 2.45544 4.8125 2.6875V3.5625"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
            </svg>
            <span class="p_small font_bold">Delete Template</span>
          </a>
        </div>
      </div>
    </div>

    <div class="table_wrapper">
      <table
        id="templates_table"
        class="keywords_table p_small reports_table"
      >
        <thead>
          <tr>
            <td class="sort_title">
              <span>Name</span>
              <i class="icon arrow_down" />
            </td>
            <td>
              <span>Created</span>
            </td>
            <td>
              <span>Last Modified</span>
            </td>
            <td>
              <span>Template Source</span>
            </td>
            <td>
              <span>Pages</span>
            </td>
            <td v-if="canEditTemplates">
              <span>&nbsp;</span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="template of templates"
            :key="template.id"
            :class="selected.includes(template.id) ? 'choosed' : ''"
            @click="selected.includes(template.id) ? selected.splice(selected.indexOf(template.id),1) : selected.push(template.id)"
          >
            <td>
              <div class="flex">
                <div class="checkbox_wrapper template_valid">
                  <input
                    :id="'check_'+template.id"
                    type="checkbox"
                  >
                  <label :for="'check_'+template.id" />
                </div>
                <span>{{ template.name }}</span>
              </div>
            </td>
            <td>
              <span>{{ formatDateTime(template.created_at) }}</span>
            </td>
            <td>
              <span>{{ formatDateTime(template.created_at) }}</span>
            </td>
            <td>
              <span
                :class="'report_status '+(template.organisation_id ? 'organisation' : template.website_id ? 'local' : 'pre-made')"
              >
                {{ template.organisation_id ? 'Organization' : template.website_id ? 'Website' : 'Local' }}
              </span>
            </td>
            <td>
              <span>{{ template.pages_count }}</span>
            </td>
            <td
              v-if="canEditTemplates"
              class="action_buttons"
            >
              <a
                v-if="template.organisation_id || template.website_id || user.user_type === 'ADMIN'"
                class="table_btn edit tooltipster"
                href="javascript:;"
                title="Template Settings"
                @click.stop="editReport({type: 'templates', report: template})"
              >
                <i class="icon settings_icon_white" />
              </a>
              <a
                v-if="template.organisation_id || template.website_id || user.user_type === 'ADMIN'"
                :href="'/reports/builder/template/'+template.id"
                class="table_btn view tooltipster"
                title="Edit Template"
                @click.stop=""
              >
                <i class="icon edit_icon_white" />
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      v-if="paginate"
      class="action_pagination_wrapper p_x_small"
    >
      <div v-if="paginate.total">
        Showing {{ paginate.from }}-{{ paginate.to }} of <span
          class="total_page"
        >{{ paginate.total }}</span> reports
      </div>
      <div v-else>
        No results
      </div>
      <div class="action_pagination">
        <a
          v-for="(link, index) in paginationLinks"
          :key="index"
          :class="link.active ? 'current_page' : ''"
          href="javascript:;"
          @click="navigatePagination({url: link.url})"
          v-html="link.label"
        />
      </div>
    </div>
  </div>
  <edit-report
    v-if="reportModal.type === 'templates'"
    @updated="fetchTemplates()"
  />
</template>

<script>
import {mapActions, mapState} from 'vuex';
import moment from 'moment';
import Swal from 'sweetalert2';
import CustomSearch from '../../global/forms/CustomSearch.vue';
import EditReport from '../modals/EditReport.vue';

export default {
  components: {
    CustomSearch,
    EditReport
  },
  emits: ['create'],
  data() {
    return {
      selected: []
    }
  },
  computed: {
    ...mapState('templates', ['templates', 'paginate']),
    ...mapState(['reportModal']),
    ...mapState('user', ['user']),
    paginationLinks() {
      return this.paginate.links.filter(function (link) {
        return link.url;
      });
    },
    tableTitle() {
      let name = this.user.organisation.name.trim();
      if (name) {
        return name + '\'s Templates';
      } else {
        return 'Templates';
      }
    },
    canViewReports() {
      return this.user.permissions.reports_permission != 'HIDDEN' ?? false;
    },
    canViewTemplates() {
      return this.user.permissions.report_templates_permission != 'HIDDEN' ?? false;
    },
    canEditReports() {
      return this.user.permissions.reports_permission === 'EDIT' ?? false;
    },
    canEditTemplates() {
      return this.user.permissions.report_templates_permission === 'EDIT' ?? false;
    },
  },
  methods: {
    ...mapActions({
      fetchTemplates: 'templates/fetchTemplates',
      searchTemplates: 'templates/searchTemplates',
      deleteTemplates: 'templates/deleteTemplates',
      navigatePagination: 'templates/navigatePagination',
      editReport: 'reportModal/openModal'
    }),
    createFrom(id, type) {
      let template = this.templates.find(template => template.id === id);
      this.$emit('create', {type: type, data: template});
    },
    deleteSelected() {
      Swal.fire({
        title: `Are you sure?`,
        icon: 'warning',
        html: `
                    You are about to delete ${this.selected.length} template${this.selected.length > 1 ? 's' : ''}.
                    <br> This action cannot be undone
                    <br><small>(Local templates will not be deleted)</small>
                `,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#d33',
        showLoaderOnConfirm: true,
        backdrop: true,
        preConfirm: async () => {
          await this.deleteTemplates(this.selected)
            .then(response => response);
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: `Deleted successfully`,
            icon: 'success'
          });
          // Check if any of the
          this.selected = [];
        }
      });
    },
    formatDateTime(datetime) {
      if (moment(datetime).isValid()) {
        if (this.user.organisation.operation_country === 'United States') {
          return moment(datetime).format('MM/DD/YYYY hh:mm');
        } else {
          return moment(datetime).format('DD/MM/YYYY hh:mm');
        }
      } else {
        return '-';
      }
    },
  }
}
</script>

<style scoped>
.table_btn.view:hover {
  background-color: #5f49af;
}

.table_btn.view {
  background-color: #8667f7;
}

.action_buttons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.items_btns .btn {
  padding: 0.563rem 1rem;
  margin: 0 0 0 .5rem;
}

.items_btns .btn.delete_btn {
  background-color: #F34F4F;
}

.items_btns .btn.delete_btn svg path {
  stroke: white;
}

.items_btns .btn.delete_btn span {
  color: white;
}

.btn.secondary_btn {
  background-color: #37B2A8;
  border: none;
}

.btn.secondary_btn span {
  color: white;
}

.btn.secondary_btn:hover {
  background-color: #0A8080;
}

.icon.create_new_icon {
  height: 1.2rem;
}

.create_new_icon {
  background-image: url("data:image/svg+xml,%3Csvg width='21' height='23' viewBox='0 0 21 23' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M16.4064 19.75H4.59326C4.41921 19.75 4.25229 19.6776 4.12922 19.5487C4.00615 19.4197 3.93701 19.2449 3.93701 19.0625V3.93752C3.93701 3.75518 4.00615 3.58031 4.12922 3.45138C4.25229 3.32245 4.41921 3.25002 4.59326 3.25002H12.4689L17.0627 8.06252V19.0625C17.0627 19.1528 17.0457 19.2422 17.0127 19.3256C16.9797 19.409 16.9314 19.4848 16.8704 19.5487C16.8095 19.6125 16.7372 19.6631 16.6575 19.6977C16.5779 19.7322 16.4926 19.75 16.4064 19.75Z' stroke='white' stroke-width='1.69' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M12.4688 3.25002V8.06252H17.0632' stroke='white' stroke-width='1.69' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M8.53125 13.5625H12.4688' stroke='white' stroke-width='1.69' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M10.5 11.5001V15.6251' stroke='white' stroke-width='1.69' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}

.delete_btn svg path {
  stroke: white;
}

.delete_btn span {
  color: white;
}
</style>
